import React, { HTMLAttributes } from 'react'
import Svg from './Svg';
import { defaultGrey } from '../../prop-types';

interface IArrowLeft{
  color?: string
}
export default function ArrowLeft({color = defaultGrey}: IArrowLeft):  any {
  return (
    <Svg
      xmlns={"http://www.w3.org/2000/svg"}
      paths={[
        {d: "M14 7l-5 5 5 5V7z", fill: color},
        {d: "M24 0v24H0V0h24z", fill: "none"}
      ]}
    />
  )
}